const WIZARD = {
  NEXT_STEP: 'Next',
  PREVIOUS_STEP: 'Back',
  REVIEW: 'Review',
  SUMMARY: 'Go to summary',
};

export { WIZARD };
